module.exports = __webpack_public_path__ + "static/media/db.acd2b217.jpg";